export default __webpack_public_path__ + "static/media/profilePicture.1f32b248.jpg";